import { Session } from '@ais-ui/auth';
import { QueryPointResult } from '../extractTargetInfo';
import { InvalidMMSIError, isValidMMSI } from './validateMMSI';

export const getTargetInfoByMMSI = async (
  session: Session,
  mmsi: number,
): Promise<QueryPointResult> => {
  if (!isValidMMSI(mmsi)) {
    throw new InvalidMMSIError(mmsi);
  }

  return await session.request('getTargetInfoByMMSI', { mmsi: mmsi });
};
